import { Box, CircularProgress } from '@mui/material';

export const Loading = () => (
  <Box textAlign="center">
    <CircularProgress data-testid="validatingCode" />
  </Box>
);
